import { differenceInDays, addDays, format, isAfter } from 'date-fns';

/**
 * Simulates a SHA-256 hash for evidence validation
 */
export const generateEvidenceHash = () => {
  return Array.from({ length: 64 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
};

/**
 * Calculates countdowns based on legislative rules
 */
export const calculateDeadline = (startDate, daysAllowed) => {
  const deadline = addDays(new Date(startDate), daysAllowed);
  const now = new Date();
  const diff = differenceInDays(deadline, now);
  
  return {
    deadlineDate: format(deadline, 'dd/MM/yyyy'),
    daysRemaining: diff,
    isOverdue: isAfter(now, deadline),
    severity: diff <= 2 ? 'critical' : diff <= 5 ? 'warning' : 'normal'
  };
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-NA', {
    style: 'currency',
    currency: 'NAD',
  }).format(value).replace('NAD', 'N$');
};

/**
 * Determines computed status of a cabinet decision based on its directives
 */
export const getDecisionStatus = (decision, directives) => {
  const decDirectives = directives.filter(d => d.parentDecisionId === decision.id);
  const now = new Date();
  const deadlinePassed = isAfter(now, new Date(decision.deadline));
  const allCompleted = decDirectives.every(d => d.status === 'Completed');
  const anyOverdue = decDirectives.some(d => d.status === 'Overdue');

  if (allCompleted) return 'Completed';
  if (deadlinePassed || anyOverdue) return 'Overdue';
  if (decDirectives.some(d => d.status === 'In Progress')) return 'In Progress';
  return 'Pending';
};

/**
 * Calculates aggregated progress for a decision from its directives
 */
export const calculateDecisionProgress = (decisionId, directives) => {
  const decDirectives = directives.filter(d => d.parentDecisionId === decisionId);
  if (decDirectives.length === 0) return 0;
  const totalProgress = decDirectives.reduce((sum, dir) => sum + dir.progress, 0);
  return Math.round(totalProgress / decDirectives.length);
};

/**
 * Gets all assignments for a given decision across all its directives
 */
export const getDecisionAssignments = (decisionId, directives, assignments) => {
  const directiveIds = directives
    .filter(d => d.parentDecisionId === decisionId)
    .map(d => d.id);
  return assignments.filter(a => directiveIds.includes(a.parentDirectiveId));
};